(function($) {

	'use strict';

	var init = function() {

        manageFolders();
    };
    
    var manageFolders = function() {

        var $folder = $('.arbo__folder');
        $folder.each(function() {
            var id = $(this).data('folder');
            var $subfolder = $(this).find('.arbo__subfolder[data-folder="' + id + '"]');
            var $toggler = $(this).find('.arbo__toggler[data-folder="' + id + '"]');
            var $parent = $(this).parent();
            $toggler.click(function() {
                $parent.find('.arbo__subfolder:not([data-folder="' + id + '"])').each(function() {
                    $(this).removeClass('active');
                    localStorage.removeItem($(this).data('folder'));
                })
                $parent.find('.arbo__toggler:not([data-folder="' + id + '"])').each(function() {
                    $(this).removeClass('active');
                });
                $toggler.toggleClass('active');
                $subfolder.toggleClass('active');
                if($toggler.hasClass('active')) {
                    localStorage.setItem(id, 'active');
                } else {
                    localStorage.removeItem(id);
                }
            });
            if(localStorage.getItem(id)) {
                $toggler.addClass('active');
                $subfolder.addClass('active');
            }
        });

    }

	$(document).ready(function() {
        if($('.arbo').length > 0) {
		    init();
        }
	});

})(jQuery);
